<ng-template #contentTemplate>
  <ng-content></ng-content>
</ng-template>
<ng-container *ngIf="!isInsideTable">
  <ng-template [ngTemplateOutlet]="contentTemplate"></ng-template>
</ng-container>
